import React from 'react';
import { Box } from '@commonsku/styles';

const DashboardTile = ({ style={}, children, ...props }) => (
    <Box padded style={{padding: '10px', marginTop: 0, boxShadow: '0px 4px 5px rgba(72, 78, 86, 0.1)', ...style}} {...props}>{children}</Box>
);

export default DashboardTile;
